import { memo } from "react"
import { CustomTable } from "../../../../../../components"
import { TableListProps } from "./types"


const TableList = ({ column, filterDropList, isLoading, row, totalPages }: TableListProps) => {

    return (
        <CustomTable
            loader={isLoading}
            column={column}
            row={row}
            selected={-1}
            order={
                filterDropList.query.sort && {
                    count: filterDropList.query?.sort?.count,
                    key: filterDropList.query?.sort?.field,
                    order: filterDropList.query?.sort?.sort,
                }
            }
            sortable={(field, sort, count) => {
                filterDropList.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
            }}
            serverSidePagination={{
                page: (filterDropList.paginationModel.page ?? 0) + 1,
                size: filterDropList.paginationModel?.pageSize ?? 20,
                totalPages: totalPages,
            }}
            handleChange={(page: number, pageSize: number) => {
                filterDropList.handlePagination({ page, pageSize })
            }}
            noContent="No se encontraron listas desplegables."
        />
    )
}

export default memo(TableList);
